export default "__VITE_ASSET__185158d5__"